export default "__VITE_ASSET__64b561fe__"